module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAkCAYAAACE7WrnAAAAr0lEQVRIS83WwQmAMAwF0HY5D+ISbuEG7uEMgriclR4Uq23zf9KDGeARSPKJd43Kt3CGvpvMUERCcLMJuhHvDzX0RFxwowp6I+u2LzSUQ+LAKKiEUFANgSEJgSAEESEUqUIMUoRYJAtpkA+kRRLIgtyQFWkPRdHaVXK0Fuxz/VosGyMarJhHLFYNNgYTExLFRAhdDQhCMBiSMAqqYTRUwlRQDlNDb8wEJdhvHq2rkROixwq2k1w0rgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeImg/wdzh_wddd_icon_fanhui@2x.png
// module id = rFgB
// module chunks = 0